<template>
  <section>
    <div
      v-for="expense in expensesList"
      :key="expense.currentVersion.id"
      class="expense-details-body"
    >
      <ExpenseDetailsPdf
        :expense="expense.currentVersion"
        :expense-attachments="expense.attachments"
        :history="expense.historyVersions"
        :batch="true"
      />
    </div>
  </section>
</template>
<script>
import ExpenseDetailsPdf from './ExpenseDetailsPdf.vue';
import { ExpensesListingGetters } from '../../expenses-listing/expenses-listing.keys';

export default {
  name: 'ExpenseBatchPDF',
  components: {
    ExpenseDetailsPdf
  },

  computed: {
    expensesList() {
      return this.$store.getters[ExpensesListingGetters.GetBatchExpensesList];
    }
  },
  updated() {
    this.$emit('readyToExport');
  }
};
</script>
<style lang="scss" scoped>
@import '../../../../../styles/colors.scss';
@import '../../../../../styles/variables.scss';

.expense-details-body {
  display: flex;
  flex-direction: column;
  float: none;
  page-break-after: always;

  .expense-pdf-footer {
    display: none;
    font-size: 10px;
  }
}
</style>
